import axios from "@/lib/request";

const headers = { AppKey: "BpLnfgDs" };
const get = (url, params) =>
  axios.request({ url, method: "get", params, headers });
const post = (url, data) =>
  axios.request({ url, method: "post", data, headers });

export const getEmployerHistoryList = params =>
  get("/v1/admin/ygb/order/historylist", params);
export const exportEmployerHistoryList = params =>
  get("/v1/admin/ygb/order/historylist/export", params);
export const getEmployerHistoryInfo = params =>
  get("/v1/admin/ygb/history/info", params);
export const getEmployerHistoryAmountList = params =>
  get("/v1/admin/ygb/order/amount/list", params);
export const calculateEmployerAddPrice = params =>
  get("/v1/admin/ygb/order/addprice", params);
export const confirmEmployerAdd = data =>
  post("/v1/admin/ygb/employee/addpass", data);
export const confirmEmployerChange = data =>
  post("/v1/admin/ygb/employee/changepass", data);
export const markEmployerHistoryInput = data =>
  post("/v1/admin/ygb/order/historyaddinput", data);
export const deleteEmployerHistory = data =>
  post("/v1/admin/ygb/history/delete", data);
export const sendEmployerHistoryEmail = data =>
  post("/v1/admin/ygb/email/send", data);
export const updateEmployerHistoryNote = data =>
  post("/v1/admin/ygb/order/history/update", data);
export const updateEmployerHistoryColour = data =>
  post("/v1/admin/ygb/history/colour/update", data);
export const updateEmployerHistoryInvoice = data =>
  post("/v1/admin/ygb/history/invoice/update", data);
export const uploadEmployerPayVoucher = data =>
  post("/v1/admin/ygb/order/uploadpayvoucher", data);
export const uploadEmployerCorrectFile = data =>
  post("/v1/admin/ygb/order/uploadcorrectfile", data);
export const uploadEmployerEndorsement = data =>
  post("/v1/admin/ygb/order/uploadendorsement", data);

export const getEmployerClaimList = params =>
  get("/v1/admin/ygb/claims/data", params);
export const saveEmployerClaim = data =>
  post("/v1/admin/ygb/claims/inputdata", data);
export const deleteEmployerClaim = data =>
  post("/v1/admin/ygb/claims/delete", data);
export const getEmployerOrderList = params =>
  get("/v1/admin/ygb/order/list", params);

export const getEmployerEmployeeLockList = params =>
  get("/v1/admin/ygb/order/employeelist", params);
export const lockEmployerEmployee = data =>
  post("/v1/admin/ygb/employeelock", data);
export const unlockEmployerEmployee = data =>
  post("/v1/admin/ygb/employeeunlock", data);

export const getEmployerEmployeeLibrary = params =>
  get("/v1/admin/ygb/employee/idcard/list", params);
export const getEmployerEmployeeInfo = params =>
  get("/v1/admin/ygb/employee/idcard/info", params);
export const saveEmployerEmployeeInfo = data =>
  post("/v1/admin/ygb/employee/idcard/save", data);

export const getEmployerInsuranceCompanies = params =>
  get("/v1/admin/cmn/insurance/company/list", params);
export const getEmployerChannels = params =>
  get("/v1/admin/cmn/channel/list", params);
export const getEmployerProductList = params =>
  get("/v1/admin/ygb/product/list", params);
export const saveEmployerProduct = data =>
  post("/v1/admin/ygb/product/save", data);
export const uploadEmployerFile = data =>
  axios.request({
    url: "/res/file/upload",
    method: "post",
    data,
    headers: { ...headers, "Content-Type": "multipart/form-data" }
  });
